<template>
  <button
    class="dacb-action-button"
    :class="{ '-loading': state === 'loading', '-done': state === 'done' }"
    @click="pressed"
  >
    <span class="dacb-text" :style="{ color: options.textColour }">{{ text }}</span>
    <span class="dacb-sending-spinner -white"></span>
    <span class="dacb-done-tick"></span>
  </button>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ActionButton",

  props: {
    text: {
      type: String,
      require: true,
      default: ""
    },
    state: {
      type: String,
      default: "normal"
    }
  },

  emits: ["pressed"],

  computed: {
    ...mapState({
      options: (state) => state.options.options
    })
  },

  methods: {
    pressed() {
      if (this.state !== "normal") return;
      this.$emit("pressed");
    }
  }
};
</script>
